import React from "react";

export default function TextIframe(props) {
  //console.log ("src", props.src)
  return (
    props.isMobile ? (
    <div 
    style={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100vw",
      height: "auto",
    }}>
          <iframe
            src={props.src}
            width="1000vw" 
            height="500vh" 
            allowtransparency="true"
          ></iframe>
    </div>
      )  : 
      <div 
    style={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "black",
      overflowY: "hidden",
      //width: "80vw",
      //height: "100vh",
      //left: "10vw",
     }}>
      (
          <iframe
            src={props.src}  
            width="2000vw" 
            height="700vh" 
            allowtransparency="true"
            frameBorder="0"
            //sandbox='allow-scripts allow-modal'
            //allowFullScreen={true}
          ></iframe>
      )
    </div>
  );
}
